import { FormattedMessage } from 'react-intl'
import {
  AppAvailableDiv,
  Cross,
  DownloadAppLink,
  Logo,
  TitleText
} from '../../styled-components'
import icClearLine from '../../images/ic_Clear_line.svg'
import appIconIos from '../../images/app_icon_ios.png'
import { useIsMobile } from '../../../../zustand/browser-store/use-browser-store'
import { useState } from 'react'

const LoginStoreBanner = ({ browser }) => {
  const [hideAppInfo, setHideAppInfo] = useState(false)
  const isMobile = useIsMobile()

  return (
    <>
      {!isMobile &&
        !hideAppInfo &&
        (browser.os === 'Android OS' || browser.os === 'iOS') && (
          <AppAvailableDiv>
            <Cross onClick={() => setHideAppInfo(true)}>
              <img src={icClearLine} alt="" width={26} />
            </Cross>
            <Logo>
              <img src={appIconIos} alt="app icon" width={36} />
            </Logo>
            <TitleText>
              <h3>docu tools</h3>
              <p>
                {browser.os === 'Android OS' && (
                  <FormattedMessage id="androidAppAvailable" />
                )}
                {browser.os === 'iOS' && (
                  <FormattedMessage id="iosAppAvailable" />
                )}
              </p>
            </TitleText>
            <DownloadAppLink
              href={
                browser.os === 'Android OS'
                  ? 'https://play.google.com/store/apps/details?id=com.docutools.app'
                  : 'https://itunes.apple.com/at/app/docu-tools-3/id1316586033?mt=8'
              }
              target="_blank"
            >
              <FormattedMessage id="show" />
            </DownloadAppLink>
          </AppAvailableDiv>
      )}
    </>
  )
}

export default LoginStoreBanner
